import { PrimaryButton } from 'ui/button';
import { AddNew16 } from 'ui/icons';
import { PageHeader } from 'ui/pageHeader';
import { Tooltip } from 'ui/tooltip';
import { ModalType, useModalContext } from '../contexts/ModalContext';

export const GoalsPageHeader = () => {
  const { openModal, closeModal } = useModalContext();

  return (
    <PageHeader
      documentTitle="Goals"
      pageActions={
        <Tooltip
          isEnabled={false}
          // TODO: What permissions are needed to create and manage goals?
          tooltipContent="You do not have permissions to create and manage goals."
        >
          <PrimaryButton
            isDisabled={false} // TODO: disable button if user does not have permissions
            onClick={() =>
              openModal(ModalType.CreateGoalModal, {
                onClose: () => closeModal(ModalType.CreateGoalModal),
              })
            }
          >
            <AddNew16 />
            Create goal
          </PrimaryButton>
        </Tooltip>
      }
    >
      Goals
    </PageHeader>
  );
};
